import { useEffect, useRef } from 'react';
import { Thumbnail } from 'react-pdf/dist/cjs';
import { FixedSizeList as List, ListChildComponentProps } from 'react-window';
import './thumbnailPanel.css';

type ThumbnailItem = {
    page: number;
};

type ThumbnailPanelProps = {
    items: ThumbnailItem[];
    currentPage: number;
    onPageSelect: (page: number) => void;
};

type RowItemData = {
    items: ThumbnailItem[];
    currentPage: number;
    onPageSelect: (page: number) => void;
};

const ITEM_HEIGHT = 140;
const THUMBNAIL_WIDTH = 100;

const Row = ({ index, style, data }: ListChildComponentProps<RowItemData>) => {
    const item = data.items[index];
    const isActive = item.page === data.currentPage;

    return (
        <div style={style}>
            <div
                className={`thumbnail-panel__item${isActive ? ' thumbnail-panel__item--active' : ''}`}
                onClick={() => data.onPageSelect(item.page)}
            >
                <Thumbnail pageNumber={item.page} width={THUMBNAIL_WIDTH} />
            </div>
        </div>
    );
};

const ThumbnailPanel = ({ items, currentPage, onPageSelect }: ThumbnailPanelProps) => {
    const listRef = useRef<List>(null);

    useEffect(() => {
        const index = items.findIndex((item) => item.page === currentPage);
        if (index >= 0 && listRef.current) {
            listRef.current.scrollToItem(index, 'smart');
        }
    }, [currentPage, items]);

    return (
        <div className="thumbnail-panel">
            <List
                ref={listRef}
                height={window.innerHeight - 140}
                itemCount={items.length}
                itemSize={ITEM_HEIGHT}
                itemData={{ items, currentPage, onPageSelect }}
                width={134}
            >
                {Row}
            </List>
        </div>
    );
};

export default ThumbnailPanel;
